var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-select',{attrs:{"dense":"","outlined":"","item-value":"value","item-text":"name","label":_vm.$t('downtime.shift'),"items":_vm.shifts,"prepend-inner-icon":"$shiftHours"},model:{value:(_vm.shift),callback:function ($$v) {_vm.shift=$$v},expression:"shift"}})
}
var staticRenderFns = []

export { render, staticRenderFns }